import './index.css';
import { useEffect } from 'react';
import { Route, Switch, Router, useLocation, Redirect } from 'wouter';
import { useAtomValue, useSetAtom } from 'jotai';
import { secretAtom, writeSecretAtom, writeSessionAtom } from './atoms/auth';
import { IS_MOCK } from './lib/api';
import { Sidebar } from './components/Sidebar';
import { Topbar } from './components/Topbar';
import { LoginPage } from './pages/auth/LoginPage';
import { StatsPage } from './pages/StatsPage';
import { OptimaLinkPage } from './pages/LavalinkPage';
import { FiveMConfigPage } from './pages/FiveMConfigPage';
import { BackroomsPage } from './pages/BackroomsPage';
import { BackroomCmdPage } from './pages/BackroomCmdPage';
import { ApiKeysPage } from './pages/ApiKeysPage';
import { useGuildData } from './hooks/useGuildData';

function AuthRedirect() {
  const [location, navigate] = useLocation();
  useEffect(() => {
    const isLogin = location === '/login' || location.startsWith('/login?');
    const search = location && location !== '/' && !isLogin ? `?r=${encodeURIComponent(location)}` : '';
    navigate(`/login${search}`);
  }, [location, navigate]);
  return (
    <div className="min-h-screen bg-[#070910] flex items-center justify-center">
      <div className="w-6 h-6 rounded-full border-2 border-t-transparent animate-spin" style={{ borderColor: 'rgba(0,255,209,0.5)', borderTopColor: 'transparent' }} />
    </div>
  );
}

function RootRedirect() {
  const [, navigate] = useLocation();
  useEffect(() => { navigate('/'); }, [navigate]);
  return null;
}

export function App() {
  const secret    = useAtomValue(secretAtom);
  const setSecret = useSetAtom(writeSecretAtom);
  const setSession = useSetAtom(writeSessionAtom);

  // In mock mode, auto-inject credentials so the login screen is skipped
  useEffect(() => {
    if (IS_MOCK && !secret) {
      setSecret('mock-password');
      setSession('mock-session-dev');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isAuthenticated = IS_MOCK || Boolean(secret);
  useGuildData(isAuthenticated);

  return (
    <Router base="/panel">
      <Switch>
        {/* Public: login */}
        {!IS_MOCK && <Route path="/login" component={LoginPage} />}

        {/* Authenticated shell */}
        <Route>
          {!isAuthenticated ? (
            <AuthRedirect />
          ) : (
            <div className="flex min-h-screen bg-[#070910] text-slate-100 font-sans">
              <Sidebar />
              <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
                <Topbar />
                <main className="flex-1 p-6 lg:p-8 overflow-y-auto scrollbar-thin">
                  <Switch>
                    <Route path="/"                component={StatsPage} />
                    <Route path="/optimaLink"      component={OptimaLinkPage} />
                    <Route path="/fivem-config"    component={FiveMConfigPage} />
                    <Route path="/backrooms">
                      <BackroomsPage />
                    </Route>
                    <Route path="/backrooms/access">
                      <Redirect to="/backrooms" />
                    </Route>
                    <Route path="/access">
                      <Redirect to="/backrooms" />
                    </Route>
                    <Route path="/backroom/logs">
                      <Redirect to="/backrooms" />
                    </Route>
                    <Route path="/backroom/cmd/*"   component={BackroomCmdPage} />
                    <Route path="/backroom/cmd"     component={BackroomCmdPage} />
                    <Route path="/apikeys"          component={ApiKeysPage} />
                    <Route><RootRedirect /></Route>
                  </Switch>
                </main>
              </div>
            </div>
          )}
        </Route>
      </Switch>
    </Router>
  );
}
